import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function PageWrapper({ children }) {
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(false);
    const t = requestAnimationFrame(() => requestAnimationFrame(() => setVisible(true)));
    return () => cancelAnimationFrame(t);
  }, [location.pathname, location.search]);

  return (
    <div className={`${visible ? "page-enter-active" : "page-enter"}`} style={{ minHeight: "60vh" }}>
      {children}
    </div>
  );
}
